<template>
  <aside class="control-sidebar control-sidebar-light" :class="{'control-sidebar-open': mostrar}">
    <form @submit.prevent="guardar" v-if="selectedItem">
      <div class="row">
        <div class="form-group col-sm-12">
          <label for="pedido_id">Pedido #{{ selectedItem.pedido_id }}</label>
        </div>        
        <div class="form-group col-sm-12">
          <label for="codigo_proyecto">Codigo Proyecto</label>
          <select class="form-control" v-model="proyecto" name="codigo_proyecto" @change="cambiarProyecto" v-validate="'required'" data-vv-validate-on="none" :disabled="!editar || !cambiarCP">
            <option :value="null">-- Seleccione --</option>
            <option v-for="proyecto in $store.state.apiData.proyectos" :value="proyecto">{{ proyecto.codigo_proyecto }}</option>
          </select>
          <span class="text-danger" v-show="errors.first('codigo_proyecto')">{{ errors.first('codigo_proyecto') }}</span>        
        </div>
        <div class="form-group col-sm-12">
          <div id="tabla-am-compras-wrapper">
            <table class="table" id="tabla-am-compras">
              <tr v-for="(item_ped,index) in selectedItem.items" class="tr-items">
                <td class="td-item-nro">{{ (index + 1) }}</td>
                <td class="td-item-desc">
                  <input type="text" v-model="item_ped.item_descripcion" class="form-control input-sm" placeholder="Desc.">
                </td>
                <td class="td-item-qty">
                  <input type="number" v-model="item_ped.qty" class="form-control input-sm" placeholder="Cant.">
                </td>         
                <td class="td-item-medida">
                  <input type="text" v-model="item_ped.unidad_medida" class="form-control input-sm" placeholder="Medida">
                </td>              
              </tr>
            </table>
          </div>
          <div id="btn-add-item-wrapper">
            <button type="button" class="btn btn-sm bg-gray" @click="agregarItem()">
              <i class="fa fa-plus"></i> Agregar
            </button>  
          </div>        
        </div>        
      </div>
      <button class="btn btn-block bg-red" v-if="editar">
        Guardar
        <div v-if="guardando" class="loading"></div>
      </button>
      <button type="button" class="btn btn-block btn-default" @click="cerrar()">
        <i class="fa fa-close"></i> Cerrar
      </button>        
    </form>
  </aside>    
</template>
<script>
import { mapGetters } from 'vuex'
import api from '../../../api'
import db from '../../../core/pouchdb'
export default {
  name: 'AMCompra',
  components: {
  },
  props: {
    item: {
      type: Object,
      required: false,
      default () {
        return null
      }
    },
    mostrar: {
      type: Boolean,
      default () {
        return false
      }
    },
    cambiarCP: {
      type: Boolean,
      default () {
        return false
      }
    },
    editar: {
      type: Boolean,
      default () {
        return false
      }
    },
    accion: {
      type: String,
      default () {
        return 'crear'
      }
    }
  },
  data () {
    return {
      selectedItem: this.item || null,
      errores: '',
      guardando: false,
      proyecto: null
    }
  },
  computed: {
    ...mapGetters([
      'getProyectoPorCodigo'
    ])
  },
  mounted () {
  },
  methods: {
    agregarItem () {
      this.selectedItem.items.push({
        item_descripcion: null,
        qty: 1,
        unidad_medida: null,
        solicitado_user: this.$store.state.user.username,
        estado: 'Pendiente'
      })
    },
    guardar () {
      let vm = this
      this.$validator.validate().then(result => {
        if (result) {
          vm.errores = ''
          vm.guardando = true

          let promises = []
          if (vm.accion === 'crear') {
            for (let i = 0; i < vm.selectedItem.items.length; i++) {
              let item = {
                pedido_id: vm.selectedItem.pedido_id,
                codigo_proyecto: vm.selectedItem.codigo_proyecto,
                nombre_proyecto: vm.selectedItem.nombre_proyecto,
                cliente_empresa: vm.selectedItem.cliente_empresa,
                item_descripcion: vm.selectedItem.items[i].item_descripcion,
                qty: vm.selectedItem.items[i].qty,
                unidad_medida: vm.selectedItem.items[i].unidad_medida,
                solicitado_user: vm.selectedItem.items[i].solicitado_user,
                validado_user: null,
                comprado_user: null,
                id_orden_compra: null,
                completado: false,
                archivar: false,
                estado: 'Pendiente'
              }

              promises.push(vm.guardarItem(item))
            }
          } else {
            let item = vm.selectedItem.items[0]
            promises.push(vm.guardarItem(item))
          }

          Promise.all(promises)
            .then(data => {
              vm.cerrar(data)
              vm.guardando = false
            }, error => {
              console.log('retorno el error al querer guardar todo')
              console.debug(error)
              vm.errores = error.message
            })
        }
      })
    },
    cerrar (items) {
      this.errores = ''
      this.$emit('am-compra:cerrar', (items || null))
    },
    cambiarProyecto () {
      if (this.proyecto) {
        this.selectedItem.codigo_proyecto = this.proyecto.codigo_proyecto
        this.selectedItem.cliente_empresa = this.proyecto.cliente_empresa
        this.selectedItem.nombre_proyecto = this.proyecto.nombre_proyecto
      } else {
        this.selectedItem.codigo_proyecto = null
        this.selectedItem.cliente_empresa = null
        this.selectedItem.nombre_proyecto = null
      }
    },
    guardarItem (item) {
      let vm = this
      if (vm.$store.state.online) {
        return api.saveCompras(item)
      } else {
        if (!item.id) {
          item.accion_email = 'Pendiente'
        }
        return db.save(item, 'compras', item.id ? 'edit' : 'create').then((response) => {
          item._rev = response.rev
          return Promise.resolve(item)
        }, error => {
          console.log('Error en guardarItem en una de las promesas')
          return Promise.reject(error)
        })
      }
    }
  },
  watch: {
    item: function (a, b) {
      if (a) {
        this.selectedItem = a
        this.proyecto = this.getProyectoPorCodigo(a.codigo_proyecto)
        this.cambiarProyecto()
      }
    }
  }
}
</script>
<style scoped>
.control-sidebar.control-sidebar-open{

  min-width: 30%;  
}
.progress-description, .info-box-text {
  white-space: normal;
  overflow: initial;
  color: #000;
  font-size: 13px;
}
.info-box-number {
  font-weight: normal;
  font-size: 13px;
  color: #999;  
}
.lnk-borrar-media {
  display: block;
  text-align: center;
}
#tabla-am-compras {
  border: 0;
  margin-bottom: 0;
}
#tabla-am-compras td {
  padding: 2px;
}
#tabla-am-compras .td-item-qty {
  max-width: 80px;
}
#tabla-am-compras .td-item-qty input {
  padding: 0 0 0 5px;
}
#tabla-am-compras .td-item-medida {
  max-width: 100px;
}
#tabla-am-compras .tr-items {
  border-bottom: 1px solid #ddd;
}
#tabla-am-compras .tr-items:last-child {
  border-bottom: none;
}
#tabla-am-compras .td-item-nro {
    font-weight: 600;
    text-align: center;
}
#tabla-am-compras-wrapper {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ddd;
  width: 100%;
}
#btn-add-item-wrapper {
    text-align: right;
    margin-top: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/views/compras/AMCompra.vue